import { useEffect, useRef } from "react";
import { PaperAirplaneIcon } from "../../Icons";

type ChatInputProps = {
  input: string;
  setInput: (value: string) => void;
  onSend: () => void;
};

export default function ChatInput({ input, setInput, onSend }: ChatInputProps) {
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    const textarea = textareaRef.current;

    if (!textarea) return;

    // textarea.focus();

    const handleInput = (e: Event) => {
      const target = e.target as HTMLTextAreaElement;
      target.style.height = "auto";
      target.style.height = `${Math.min(target.scrollHeight, 120)}px`; // cap height
    };

    textarea.addEventListener("input", handleInput);
    return () => textarea.removeEventListener("input", handleInput);
  }, []);

  return (
    <div className="p-3 border-t bg-white flex items-end gap-2">
      <textarea
        ref={textareaRef}
        autoFocus={true}
        value={input}
        onChange={(e) => setInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            onSend();
          }
        }}
        placeholder="Type a message..."
        rows={1}
        className="w-full resize-none border rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-200 pr-10 overflow-y-auto"
        style={{
          minHeight: "40px",
          maxHeight: "120px",
        }}
      />

      <button
        onClick={onSend}
        disabled={!input.trim()}
        className={`rounded-lg px-4 py-2 font-medium transition-all shrink-0 ${
          input.trim()
            ? "bg-custom-blue-medium hover:bg-blue-700 text-white"
            : "bg-gray-200 text-gray-400 cursor-not-allowed"
        }`}
      >
        <PaperAirplaneIcon />
      </button>
    </div>
  );
}
